module.exports = __webpack_public_path__ + "static/media/oreobackpack3.36057d21.png";